/// <amd-module name="Wit/SprintsHub/SprintsView/Utils/ClassificationPathUtils" />
import { startsWith } from "VSS/Core/Util/String";
import { compareFieldValues } from "Wit/WorkItemModel/WorkItem/FieldUtils";

export function isClassificationPathEqualOrUnder(pathToCheck: string, basePath: string, includeChildren: boolean) {
    const classificationPart = basePath + "\\";
    if (compareFieldValues(basePath, pathToCheck, true)) {
        // The paths are the same
        return true;
    }

    if (includeChildren && pathToCheck) {
        // The classification part is under the path to check
        return startsWith(pathToCheck, classificationPart, true);
    }
    return false;
}

/**
 * Match all repeating backslashes at the start of a string
 */
const startingBackslashes = new RegExp(/^\\+/);

export function trimStartingBackslashes(path: string) {
    return path.replace(startingBackslashes, "");
}
